import isEmpty from 'lodash-es/isEmpty.js'

export const getValue = value => (!isEmpty(value) ? value : '-')

export const getDropdownLabelByValue = (options, value) => {
  const stringValue = String(value)
  const foundOption = options.find(option => String(option.value) === stringValue)
  return foundOption?.description ?? foundOption?.label
}
